import { types } from 'mobx-state-tree';

const Role = types
  .model('Role', {
    id: types.identifierNumber,
    name: types.string
  });

export default Role;